export default __webpack_public_path__ + "static/media/penguin-2.c6b75f57.png";